module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/credits-rate-desktop-715bbeaf34bad0be27a7562d014a5d1c.png";